export default "__VITE_ASSET__qPuO5vcN__"